import type { ReactNode } from 'react';

interface FieldProps {
  label: string;
  hint?: ReactNode;
  error?: string;
  htmlFor?: string;
  children: ReactNode;
  optional?: boolean;
}

export function Field({ label, hint, error, htmlFor, children, optional }: FieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={htmlFor}
        className="flex items-baseline justify-between text-[13px] font-medium text-ink"
      >
        <span>{label}</span>
        {optional && <span className="text-ink-faint font-normal">необязательно</span>}
      </label>
      {children}
      {hint && !error && <p className="text-[12px] text-ink-muted leading-snug">{hint}</p>}
      {error && <p className="text-[12px] text-danger leading-snug">{error}</p>}
    </div>
  );
}

const baseInput =
  'w-full rounded-input border border-line bg-surface px-3.5 py-2.5 text-[15px] text-ink placeholder:text-ink-faint transition-colors focus:outline-none focus:border-accent focus:ring-4 focus:ring-accent/10';

export function TextInput(
  props: React.InputHTMLAttributes<HTMLInputElement>,
) {
  return <input {...props} className={`${baseInput} ${props.className ?? ''}`} />;
}

export function TextArea(
  props: React.TextareaHTMLAttributes<HTMLTextAreaElement>,
) {
  return (
    <textarea
      rows={5}
      {...props}
      className={`${baseInput} resize-y min-h-[120px] ${props.className ?? ''}`}
    />
  );
}

export function Select(
  props: React.SelectHTMLAttributes<HTMLSelectElement>,
) {
  return (
    <select
      {...props}
      className={`${baseInput} appearance-none bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2216%22 height=%2216%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%2364748b%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22><polyline points=%226 9 12 15 18 9%22/></svg>')] bg-no-repeat bg-[right_12px_center] pr-10 ${props.className ?? ''}`}
    />
  );
}
